module.exports = __webpack_public_path__ + "static/lab_logo-832710d257a040145ff0137f2eb0b031.png";